import React, { Fragment, useEffect } from 'react';
import {
  cssColorValue,
  HorizontalRule,
  PopoverNavigation,
  semanticColors,
  spacer12,
  spacer8,
} from '@spotify-internal/encore-web/core';
import styled from 'styled-components';

import { isLinkVisible } from 'components/Masthead/shared/utils';
import { MastheadLinkOrLinkListArray } from 'lib/sanity/types';
import { UbiMastheadHeader } from 'utils/ubi/pages/useUbiHeader';
import { ProfileNavigationItem } from 'components/Masthead/Header/Profile/NavigationItem';
import { isMastheadLinkList } from 'utils/type-guards';

const StyledPopoverNavigation = styled(PopoverNavigation)`
  padding: ${spacer12};
`;

const Divider = styled(HorizontalRule)`
  background-color: ${cssColorValue(semanticColors.backgroundTintedHighlight)};
  margin-block: ${spacer8};
  &:last-of-type {
    display: none;
  }
`;

interface Props {
  profileLinks?: MastheadLinkOrLinkListArray;
  ubi: UbiMastheadHeader;
  isLoggedIn: boolean;
}

export const ProfileLinksPopoverNavigation = ({ isLoggedIn, profileLinks, ubi }: Props) => {
  useEffect(() => {
    ubi.logProfileLinksContainerImpression('header');
  }, [ubi]);

  return (
    <StyledPopoverNavigation>
      {profileLinks
        ?.filter(item => isMastheadLinkList(item) || isLinkVisible(item, isLoggedIn))
        .map((item, index) => {
          return (
            <Fragment key={index}>
              <ProfileNavigationItem ubi={ubi} item={item} isLoggedIn={isLoggedIn} />
              <Divider />
            </Fragment>
          );
        })}
    </StyledPopoverNavigation>
  );
};
